module.exports = __webpack_public_path__ + "static/media/Thumbnail.8b3358f8.png";